import Hero from "../../components/Hero";
import CalculatorsImag1 from "../../../assets/images/Calculator1.jpg";
import BorrowCalculator from "../../calculators/MortgageBorrowCalculator";


const MortgageBorrowCalculatorsPage = () => {
    return (
      <div>
        <Hero title="Mortgage Borrow" subtitle="" backgroundImage={CalculatorsImag1} />
                <BorrowCalculator />
            {/* <div className="landing-page">
            </div> */}
        </div>
    );
}

export default MortgageBorrowCalculatorsPage;